<div class="container-md">


  <div class="row" style="padding-top:20px">
    <div class="col p-0">
      <luna-carousel></luna-carousel>
    </div>
  </div>

  <div class="row loginBox">
    <div class="col-md-6 p-5">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <h1 class="login-heading">Partner Order Portal Login</h1>

        @if (errorMessage) {
          <div class="alert alert-danger">
            {{errorMessage}}
          </div>
        }

        <div class="login-fields">
          <div class="mb-3">
            <label for="username" class="visually-hidden">Email address</label>
            <div>
              <input id="username" type="email" formControlName="username" class="form-control login-input" autocomplete="email" placeholder="Email address">
              @if (submitted && loginForm.get('username')?.errors) {
                <div class="text-danger">
                  @if (loginForm.get('username')?.errors?.['required']) {
                    <div>Email is required</div>
                  }
                  @if (loginForm.get('username')?.errors?.['email']) {
                    <div>Please enter a valid email address</div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="mb-2">
            <label for="password" class="visually-hidden">Password</label>
            <div>
              <input id="password" type="password" formControlName="password" class="form-control login-input" autocomplete="current-password" placeholder="Password">
              @if (submitted && loginForm.get('password')?.errors) {
                <div class="text-danger">
                  @if (loginForm.get('password')?.errors?.['required']) {
                    <div>Password is required</div>
                  }
                  @if (loginForm.get('password')?.errors?.['minlength']) {
                    <div>Password must be at least 6 characters</div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="forgot-password-link">
            <a [routerLink]="'/forgotpassword'">Forgot password?</a>
          </div>

          <button type="submit" class="btn main-button login-button" [disabled]="loading">
            @if (loading) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            {{loading ? 'Logging in...' : 'Login'}}
          </button>

          <button type="button" class="btn main-button login-button" (click)="loginWithSSO()">
            Login with SSO
          </button>

          <button type="button" class="trouble-link" (click)="openTroubleshoot()">
            Trouble logging in?
          </button>
        </div>
      </form>
    </div>
    <div class="col-md-6 p-5">
      <h2 class="login-heading">Interested in Luna Contact Lens Fulfillment?</h2>

      <p class="fulfillment-intro">
        This portal is for current Luna fulfillment clients. If you're exploring fulfillment options, learn how Luna can help streamline contact lens delivery with end-to-end services.
      </p>

      <div class="d-grid gap-2 col-sm-4 mx-auto">
        <a class="btn main-button" href="https://luna.io/contact-lens-fulfillment/" target="_blank" rel="noopener noreferrer">Learn More</a>
      </div>
    </div>
  </div>
</div>
